module.exports = __webpack_public_path__ + "static/media/checkoutInvoice.d60bdc77.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/feature/android/checkoutInvoice.gif
 ** module id = 585
 ** module chunks = 0
 **/